import {Component, EventEmitter, Input, OnInit, Output, ViewChild, ViewContainerRef } from '@angular/core';
import { TasksDialogComponent } from './tasks-dialog/tasks-dialog.component';
import { ModalConfirmationComponent } from '../../../shared/modal-confirmation/modal-confirmation.component';
import { TasksApiService } from '../../../services/api/tasks/tasks-api-service.service';
import { DialogService } from '../../../services/dialog-service/dialog.service';
import { OptionsApiService } from '../../../services/api/options/options-api.service';
import { RequestApiService } from '../../../services/api/request/request-api.service';
import { ApiAdminGroupsService } from 'src/app/services/api/admin/admin-groups-api/admin-groups-api.service';
import { SdeskHelper } from 'src/app/shared/helper/SdeskHelper';
import { SelectionModel } from '@angular/cdk/collections';
import {ActivatedRoute, Router} from "@angular/router";
import { RequestCreatEditDialogComponentComponent } from '../request/request-creat-edit-dialog.component/request-creat-edit-dialog.component.component';
import { SharedService } from 'src/app/shared/service/shared-service';

@Component({
  selector: 'app-tasks',
  templateUrl: './tasks.component.html',
  styleUrls: ['./tasks.component.css']
})
export class TasksComponent implements OnInit {
 
  @Input() requestId = null;
  @Output() refreshParentComponent = new EventEmitter<any>();
  @Output() childChanges: EventEmitter<any> = new EventEmitter();

  data;
  options;
  isLoading = true;
  requestDetails;
  isShowstatus: boolean = true;
  newTask;
  isShowinline: boolean = false;
  agentsEdit = [];
  agentsDisplay = [];
  public selectedTickets = new SelectionModel(
    true,   // multiple selection or not
    [] // initial selected values
  );
 
  //Paginator variables
  public totalCount;
  first: number = 0;
  rows: number = 50;
  showingRowscount: number = 50;
  fromRowscount: number = 1;
  currentPage: number = 1;
  currentPerPage: number = 50;
  public task_storage: { taskId: number; perPage: number; page: number }[];
  viewName: string;
  public viewData;
  task: any;
 
  constructor(private sharedService: SharedService, private route: ActivatedRoute,private requestApi: RequestApiService, private optionsApi: OptionsApiService, private tasksApiService: TasksApiService, private dialogService: DialogService, private viewReference: ViewContainerRef,
    private apiAdminGroupsService: ApiAdminGroupsService
  ) {
  }
 
  ngOnInit(): void {
    this.getRequestDetails();
    this.route.paramMap.subscribe(params => {
      this.getData();
      this.setFirstPageIndex();
      this.refreshParentComponent.emit();
      this.clearSelection();
    })
    this.optionsApi.AllOptions().then(response => this.options = response);
  }
  
  refreshParent() {
    this.refreshParentComponent.emit();
  }
 
  getData(showLoading = true) {
    this.isLoading = showLoading;
    console.log("is this")
    this.task_storage = SdeskHelper.getViewBytaskId('TaskView_pagination', this.viewName) ;
    if (this.task_storage.length > 0) {
      this.currentPage = this.task_storage[0].page;
      this.currentPerPage = this.task_storage[0].perPage;
  } else {
      this.currentPage = 1;
      this.currentPerPage = 50;
  }
    // this.rows =this.currentPerPage;
    this.rows = this.currentPerPage;
    this.first = (this.currentPage - 1) * this.currentPerPage;

    if (!this.requestId) {
      this.tasksApiService.listMyTasks(this.currentPage, this.currentPerPage).then(response => {
        // The response will contain both the tasks and the totalRecords
        this.data = response.tasks.map(task => ({
          ...task,
          // Instructions: this.stripHtml(task.Instructions),
          Instructions: task.Instructions,
          isEditing: false,
          isGroupEditing: false,
          isAgentEditing: false,
          availableAgents: []
        }));
        SdeskHelper.limitString(this.data, 50, true);
 
        // Set the total count for pagination or display purposes
        this.totalCount = response.totalRecords;
 
        this.isLoading = false;
      }).catch(error => {
        console.error('Error fetching tasks:', error);
        this.isLoading = false;
      });
    } else {
      this.tasksApiService.listRequestTasks(this.requestId).then(response => {
        this.data = response.map(task => ({
          ...task,
          isEditing: false,
          isGroupEditing: false,
          isAgentEditing: false,
          availableAgents: []
        }));
 
        SdeskHelper.limitString(this.data, 50, true);
        this.isLoading = false;
      }).catch(error => {
        console.error('Error fetching request tasks:', error);
        this.isLoading = false;
      });
    }
  }
 
  deletefromArray(index) {
    this.childChanges.emit(true);
    this.isShowstatus = true;
    this.isShowinline = false;
  }
  getRequestDetails() {
    this.isLoading = true;
    if (this.requestId != null) {
      this.requestApi.get(this.requestId).then(response => {
        this.requestDetails = response;
        this.isLoading = false
      }
      )
    }
  };

  create() {
    // Replace null with Component
    this.dialogService.createDialog(TasksDialogComponent, null, this.viewReference)
      .then(dialogSaved => {
        this.getData();
      }, dialogCancelled => {

      })
  }

  markComplete(id) {
    this.tasksApiService.markComplete(id).then(response => this.getData(false))
  }

  markPending(id) {
    this.tasksApiService.markPending(id).then(response => this.getData(false))
  }

  addNewTask(requestDetails) {
    this.isShowstatus = false;
    this.isShowinline = true;
      this.newTask = {
      TaskName: '',
      Instructions: '',
      RequestId: this.requestId,
      TypeId: requestDetails.TypeId,
      GroupId: null,
      LocalId: requestDetails.LocalId,
      Completed: false,
      SendCompletionEmail: false,
      ShowCompletionEmailDialog: false,
      isEditing: true
    };
  }
  
  filterAgentsdata(newtask, event) {
    console.log('task', newtask)
    console.log('event', event)
    this.newTask.AgentId = "";
 
    if (newtask.GroupId) {
      this.apiAdminGroupsService.get(newtask.GroupId)
        .then(r => {
          this.agentsEdit = r.Members.map(item => {
            return { id: item.Id, name: item.Name }
          })
        });
      this.isLoading = false;
    }
  }
 
  toggleEdit(task: any, isEditing: boolean) {
    task.isEdittable = isEditing;
    this.filterAgents(task);
  }
  editTask(taskId, requestId, typeId) {
    this.dialogService.createDialog(RequestCreatEditDialogComponentComponent, { taskId: taskId, requestId: requestId, typeId: typeId }, this.viewReference)
      .then(dialogSaved => {
        if (dialogSaved) {
          // Refresh the task list and the thread
          this.getData(); // Refresh the task list
          this.sharedService.reloadAFT();
        }
      })
      .catch(dialogCancelled => {
        // Handle cancellation if needed
        this.getData(false); // Refresh the task list
        this.sharedService.reloadAFT();
      });
  }
 
  toggleAgents(task, index) {
    this.data[index].AgentId = '';
    this.data[index].AgentName = '';
    this.setGroup(task.Id,task.GroupId);
    this.loadAgentsForGroup(task);
  }
  filterAgents(task) {
    if(task.GroupId)
      {
    this.apiAdminGroupsService.get(task.GroupId)
      .then(r => {
        this.options.agent = r.Members.map(item => {
          return { id: item.Id, name: item.Name }
        })
      });
    this.isLoading = false;
      }
  }
 
  setGroup(taskId, groupID) {
    if (taskId === undefined && groupID) {
      if (this.data.length > 0) {
        this.data[0].GroupId = groupID;
      }
 
    } else {
      if(groupID)
        {
          this.tasksApiService.assignToGroup(taskId, groupID).then(response => console.log('updated'))
        }
    }
  }

  setAgent(task,id, agentId,status) {
    if (agentId) {
      this.tasksApiService.assignToAgent(id, agentId).then(response =>{
        if(status==='new')
          {
            this.getData()
          }
        else
        {
          console.log('updated agent');
        }
      })
    }
    else{
      task.AgentName = "";
      this.tasksApiService.unassignAgent(id).then(response =>{
        console.log('unassigned agent');
      })
    }
  }
 
  saveTaskChanges(task: any) {
    console.log("tjis is ")
    if (task.Id) {
      this.tasksApiService.updateTask(task.Id, task).then(() => {
 
        task.isEditing = false;
        task.isEdittable = false;
        this.childChanges.emit(true);
        this.getData()
 
      }).catch(error => {
        console.error('Failed to update task', error);
      });
    }
  }
 
  savenewTaskChanges(task) {
    this.isShowinline = false;
   
    this.tasksApiService.create(task).then(response => {
      this.isShowstatus = true;
      task.Id = response;
      task.isEditing = false;
      if(task.AgentId)
        {
          this.setAgent(task,response, task.AgentId, 'new');
        }
   
      task.isEdittable = false; 
      this.childChanges.emit(true);
      this.getData();
    }).catch(error => {
      console.error('Failed to create task', error);
    });
  }
 
  sendEmail(id, emailContents, requestId) {
    this.requestApi.threadReply(requestId, emailContents, [], 1, null, false).then(response => {
      this.markComplete(id);
      this.refreshParent();
    });
  }
 
  stripHtml(html) {
    var temporalDivElement = document.createElement("div");
    temporalDivElement.innerHTML = html;
    return temporalDivElement.textContent || temporalDivElement.innerText || "";
  }
 
  edit(id) {
    // Replace null with Component
    this.dialogService.createDialog(TasksDialogComponent, id, this.viewReference)
      .then(dialogSaved => {
        this.getData();
      }, dialogCancelled => {
 
      })
  }
 
  delete(id) {
    this.dialogService.createDialog(ModalConfirmationComponent, 'Are you sure?', this.viewReference)
      .then(confirmed => {
        this.tasksApiService.delete(id).then(response => this.getData())
        this.childChanges.emit(true);
      }, cancelled => null)
  }
 
  //Function uses for pagination
  onPageChange(event) {
    let page = event.page + 1;
    let perpage = event.rows;
    this.currentPage = page;
    this.currentPerPage = perpage;
 
    this.rows = this.currentPerPage;
    this.first = (this.currentPage - 1) * this.currentPerPage;

    this.showingRowscount = page * perpage;
    this.fromRowscount = ((page - 1) * perpage) + 1;
    // this.currentPerPage = perpage;
    SdeskHelper.storePaginationData('TaskView_pagination', 'taskId', null, this.viewName, perpage, page);
    this.getData();
  }

  clearSelection() {
    this.selectedTickets.clear();
  }

  setFirstPageIndex() {
    this.first = (this.currentPage - 1) * this.rows;
  }
  
  checkboxIsAllSelected(): boolean {
    if (this.data) {
      return this.selectedTickets.selected.length === this.data.length;
    } else {
      return this.selectedTickets.selected.length === 0;
    }
}
 
checkboxToggleAll(): void {
    if (this.checkboxIsAllSelected()) {
        this.data.forEach(task => this.selectedTickets.deselect(task.Id));
    } else {
        this.data.forEach(task => this.selectedTickets.select(task.Id));
    }
}


  toggleGroupEdit(task: any, index: number) {
    this.data.forEach(t => {
      if (t.Id !== task.Id) {
        t.isGroupEditing = false;
        t.isAgentEditing = false;
      }
    });
  
    task.isGroupEditing = true;
  }

  toggleAgentEdit(task: any, index: number) {
    this.data.forEach(t => {
      if (t.Id !== task.Id) {
        t.isGroupEditing = false;
        t.isAgentEditing = false;
      }
    });
  
    task.isAgentEditing = true;
  
    this.loadAgentsForGroup(task);
  }

  handleGroupChange(task: any, id, index: number) {
    task.AgentId = null;
    task.AgentName = "";
  
    const selectedGroup = this.options?.group.find(g => g.id === task.GroupId);
    if (selectedGroup) {
      task.GroupName = selectedGroup.name;
    }    else{
      task.AgentName = "";
      task.GroupName = "";
      this.tasksApiService.unassignGroup(id).then(response =>{
        console.log('unassigned Group');
      })
    }
    this.tasksApiService.unassignAgent(id).then(response =>{
      console.log('unassigned agent');
    })
  
    this.setGroup(task.Id, task.GroupId);
    this.loadAgentsForGroup(task);
  
    task.isAgentEditing = true;
  }

  loadAgentsForGroup(task: any) {
    if (task.GroupId) {
      this.apiAdminGroupsService.get(task.GroupId)
        .then(response => {
          task.availableAgents = response.Members.map(item => {
            return { id: item.Id, name: item.Name };
          });
        })
        .catch(error => {
          console.error('Error loading agents for group:', error);
          task.availableAgents = [];
        });
    } else {
      task.availableAgents = [];
    }
  }

  saveGroupChange(task: any) {
    setTimeout(() => {
      task.isGroupEditing = false;
    }, 200);
  }

  saveAgentChange(task: any) {
    setTimeout(() => {
      task.isAgentEditing = false;
    
      if (task.AgentId) {
        const availableAgents = task.availableAgents || this.options.agent;
        const selectedAgent = availableAgents.find(a => a.id === task.AgentId);
        if (selectedAgent) {
          task.AgentName = selectedAgent.name;
        }
      } else {
        task.AgentName = "";
      }
    }, 200);
  }

}